module.exports = __webpack_public_path__ + "static/3p-021f32226e01a7377eb18bc88190a50b.webp";